import { render, staticRenderFns } from "./bbsrelease.vue?vue&type=template&id=86abf2b0&scoped=true"
import script from "./bbsrelease.vue?vue&type=script&lang=js"
export * from "./bbsrelease.vue?vue&type=script&lang=js"
import style0 from "./bbsrelease.vue?vue&type=style&index=0&id=86abf2b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86abf2b0",
  null
  
)

export default component.exports